export const getOrgDetailsQuery = (id) => {
    console.log(id);
    var params = {
        "query": {
            "bool": {
                "must": [
                    {
                        "match": { "id.keyword": id }
                    }
                ]
            }
        }
    };
    return params
}

export const getRoleListQuery = () => {

    var params = {
        "query": {
            "match_all": {}
        }
    }
    console.log(params);
    return params;
}


export const getOrgListQuery = (criteria) => {
    var q = {};
    var { searchKeyword, page, order, sort } = criteria;
    if (searchKeyword !== '') {
        q = {
            ...q,
            "should": [
                { "wildcard": { "id.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "name.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "code.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "email.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "phone.keyword": { "value": `*${searchKeyword}*` } } },
            ],
            "minimum_should_match": 1
        }
    }

    var params = {
        "query": {
            "bool": q
        },
        "track_scores": true,
        "from": page * 10,
        "sort": {
            "_script": {
                "type": "string",
                "script": {
                    "lang": "painless",
                    "source": "doc['siteName'].value + doc['clientId'].value"
                },
                "order": order
            }
        },
        "sort": {
            [sort]: { "order": order }
        }
    }
    return params;
}


export const getUserDetailsQuery = (id) => {
    var params = {
        "query": {
            "bool": {
                "must": [
                    {
                        "match": { "id.keyword": id }
                    }
                ]
            }
        }
    };
    return params
}

export const getUserListQuery = (criteria) => {
    var q = {};
    var { searchKeyword, page, order, sort } = criteria;
    if (searchKeyword !== '') {
        q = {
            ...q,
            "should": [
                { "wildcard": { "id.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "firstName.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "lastName.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "email.keyword": { "value": `*${searchKeyword}*` } } },
                { "wildcard": { "phone.keyword": { "value": `*${searchKeyword}*` } } },
            ],
            "minimum_should_match": 1
        }
    }

    var params = {
        "query": {
            "bool": q
        },
        "track_scores": true,
        "from": page * 10,
        "sort": {
            "_script": {
                "type": "string",
                "script": {
                    "lang": "painless",
                    "source": "doc['siteName'].value + doc['clientId'].value"
                },
                "order": order
            }
        },
        "sort": {
            [sort]: { "order": order }
        }
    }
    return params;
}


export const getList = (criteria) => {
    var { order, sort, page } = criteria;
    var params = {};

    console.log(criteria);

    if (criteria.searchKeyword?.length > 0) {
        params = {
            "query": {
                "wildcard": {
                    "id.keyword": {
                        "value": `*${criteria.searchKeyword.toUpperCase()}*`
                    }
                }
            },
            "from": page * 10,
            "sort": { [sort]: order }
        }
        console.log(JSON.stringify(params));
        return params;
    } else {
        params = {
            "query": {
                "match_all": {}
            },
            "from": page * 10,
            "sort": { [sort]: order }
        }
        console.log(JSON.stringify(params));
        return params;
    }
}

export const getDetails = (id) => {
    var params = {
        "query": {
            "bool": {
                "must": [
                    {
                        "match": { "id.keyword": id }
                    }
                ]
            }
        }
    };
    return params
}

export const getRoomListQuery = (criteria) => {
    var { order, sort, page, projectId } = criteria;

    var q = {
        "match": {
            "projectId": projectId
        }
    };

    var params = {
        "query": {
            "bool": {
                "must": q
            }
        },
        "track_scores": true,
        "from": page * 10,
        "sort": { [sort]: order }
    }
    return params;
}

export const getDetailsUsTires = (id) => {
    var params = {
        "query": {
            "bool": {
                "must": [
                    {
                        "match": { "_id": id }
                    }
                ]
            }
        }
    };
    return params
}

export const getAddByZip = (zip) => {
    var params = {
        "query": {
            "bool": {
                "must": {
                    "match": {
                        "id.keyword": zip
                    }
                }
            }

        }
    }
    return params;
}
